import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'dateWithoutTimezone',
    standalone: false
})
export class DateWithoutTimezonePipe implements PipeTransform {

  transform(date: Date, args?: any): any {
    if (!date) {
      return;
    }

    const updatedDate = moment(date).utc(false).format('YYYY/MM/DD HH:mm:ss');

    return updatedDate;
  }

}
